import React from "react";
import { useIntl } from "react-intl";
import { H4 } from "@components/Heading";
import { Container, H1 } from "./Error";
import Div from "@components/Div";
import LoginBg from "@assets/login-bg.svg";

const MaintenancePage = () => {
  const { messages } = useIntl();
  return (
    <Container
      width={"fit-content"}
      height="100vh"
      display="flex"
      flexDirection="column"
      backgroundImage={`url(${LoginBg})`}
    >
      <Div width={1} display="flex" m="auto">
        <Div display="flex" flexDirection="column" justifyContent="center">
          <H1 mb={3} textAlign={"center"}>
            {messages.site_under_maintenance}
          </H1>
          <H4 textAlign={"center"}>{messages.des_site_under_maintenance}</H4>
        </Div>
      </Div>
    </Container>
  );
};

export default MaintenancePage;
